import { Record } from 'immutable';
import { schema } from 'normalizr';

export const RmaFee = new Record({
  id: undefined,
  reason: undefined,
  fee: undefined,
  obsolete: undefined,
});

export const rmaFeeSchema = new schema.Entity('rmaFees');

// for reading in nested models, object with { field: schema }
// rmaFeeSchema.define({  });
